import { createAtomState } from '@/ui/utilities/state/jotai/utils/createAtomState';

// Which signed-in person and active workspace the Apollo cache holds data for,
// as "<Clerk user id>:<Clerk organization id>". Null before the first load.
export const apolloCacheSessionKeyState = createAtomState<string | null>({
  key: 'apolloCacheSessionKeyState',
  defaultValue: null,
});
